module.exports = __webpack_public_path__ + "img/ftp.84669010.svg";